import React from 'react';
import { Text } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/tokens';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
interface BannerCountProps {
  active_index: number;
  total_count: number;
}

export const BannerCounter: React.FC<React.PropsWithChildren<BannerCountProps>> = ({ active_index, total_count }) => {
  if (!total_count) {
    return null;
  }

  return (
    <Wrapper>
      <Text variant='Caption_12_Medium' as='span' color='staticWhite'>
        {active_index + 1}
      </Text>
      <Divider />
      <Text
        variant='Caption_12_Medium'
        as='span'
        color='staticWhite'
        css={css`
          opacity: 0.7;
        `}
      >
        {total_count}
      </Text>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: absolute;
  right: 8px;
  bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 4px 10px;
  z-index: 1;
  height: 24px;
  background: ${vars.color.onImageBlackOpacity30};
  border-radius: 100px;
`;

const Divider = styled.span`
  width: 1px;
  height: 10px;
  background: ${vars.color.staticWhite};
  opacity: 0.2;
  margin: 0 6px;
`;
